/**
 * Lacrosse theme overrides that should survive Impulse theme.js upgrades.
 */
(() => {
  const bindHeaderSearchClose = () => {
    const closeBtn = document.getElementById('SearchClose');
    if (!closeBtn || closeBtn.dataset.lacrosseBound === 'true') {
      return;
    }

    closeBtn.dataset.lacrosseBound = 'true';
    closeBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      // Impulse 9.2 closes the header search drawer via this event
      // (stock UI used .btn--close-search inside <predictive-search>).
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    });
  };

  const focusHeaderSearchInput = () => {
    const container = document.querySelector('.site-header__search-container');
    const input = document.querySelector('.site-header__search-input');
    if (!container || !input || !container.classList.contains('is-active')) {
      return;
    }
    input.focus();
  };

  const bindHeaderSearchFocus = () => {
    document.querySelectorAll('.js-search-header').forEach((btn) => {
      if (btn.dataset.lacrosseFocusBound === 'true') {
        return;
      }

      btn.dataset.lacrosseFocusBound = 'true';
      btn.addEventListener('click', () => {
        // theme.js opens the drawer in an earlier listener on this same click.
        // Stock Impulse focused the input from <predictive-search> on
        // predictive-search:open; that element is no longer in the header.
        focusHeaderSearchInput();
        window.setTimeout(focusHeaderSearchInput, 100);
      });
    });
  };

  const refreshAos = () => {
    if (!window.AOS) {
      return;
    }
    window.AOS.refresh();
  };

  const bindAccordionAosRefresh = () => {
    document.querySelectorAll('[data-aria-accordion]').forEach((accordion) => {
      if (accordion.dataset.lacrosseAosBound === 'true') {
        return;
      }
      accordion.dataset.lacrosseAosBound = 'true';

      // Bubble phase runs after the accordion button opens the panel,
      // so refresh measures the images at their real height.
      accordion.addEventListener('click', (evt) => {
        if (!evt.target.closest('.accordion__trigger')) {
          return;
        }
        refreshAos();
      });
    });
  };

  const bindHeaderSearch = () => {
    bindHeaderSearchClose();
    bindHeaderSearchFocus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeaderSearch);
    document.addEventListener('DOMContentLoaded', bindAccordionAosRefresh);
  } else {
    bindHeaderSearch();
    bindAccordionAosRefresh();
  }
})();
